// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"2743a3ff","7":"314b5a03","71":"19c521a2","74":"8143aa08","120":"85a5e3b7","181":"e88f2c37","415":"05653d3a","442":"80bbb678","476":"27bdf872","584":"f0590074","610":"5b2273f8","681":"5d5f2ac4","723":"85026e63","739":"22d9dc6c","888":"fd67d458"}[chunkId] + ".chunk.js";
};